import { createFileRoute, Link } from '@tanstack/react-router';
import { z } from 'zod';
import { Button } from '@eureca/ui';
import { getProgramSuspenseQueryOptions } from '@eureca/candidate-api-sdk/hooks';
import ProgramDetailPage from '@/features/programs/ProgramDetailPage';
import { programDetailSearchSchema } from '@/features/programs/program-detail-search.schema';

const paramsSchema = z.object({ id: z.string().min(1) });

function ProgramDetailErrorFallback() {
  return (
    <main
      className="flex flex-1 flex-col items-center justify-center gap-3 px-5 py-12"
      data-testid="program-detail-not-found"
    >
      <h1 className="text-2xl font-semibold">Programa não encontrado</h1>
      <p className="text-sm text-muted-foreground">
        O programa que você procura não está disponível.
      </p>
      <Button asChild type="button">
        <Link to="/programas">Ver todos os programas</Link>
      </Button>
    </main>
  );
}

export const Route = createFileRoute('/programas/$id')({
  params: {
    parse: (raw) => paramsSchema.parse(raw),
    stringify: ({ id }) => ({ id: String(id) }),
  },
  validateSearch: programDetailSearchSchema,
  loader: ({ context, params }) =>
    context.query.ensureQueryData(getProgramSuspenseQueryOptions(params.id)),
  errorComponent: ProgramDetailErrorFallback,
  component: ProgramDetailPage,
});
